// Primes a shared AudioContext on the member's FIRST interaction anywhere in the app (login,
// navigation, any tap/click/keypress). Once primed, emergency alert audio can autoplay instantly
// when the safety widget appears — no further gesture required, on desktop and mobile.
let ctx = null;
let unlocked = false;

export function getPrimedCtx() {
  if (!ctx) {
    try {
      const C = window.AudioContext || window.webkitAudioContext;
      if (!C) return null;
      ctx = new C();
    } catch { return null; }
  }
  if (ctx.state === "suspended") { ctx.resume().catch(() => {}); }
  return ctx;
}

function unlock() {
  const c = getPrimedCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  if (unlocked) return;
  try {
    const b = c.createBuffer(1, 1, c.sampleRate);
    const s = c.createBufferSource();
    s.buffer = b;
    s.connect(c.destination);
    s.start(0);
    unlocked = true;
  } catch { /* noop */ }
}

if (typeof window !== "undefined") {
  ["pointerdown", "touchstart", "keydown", "click"].forEach((e) =>
    window.addEventListener(e, unlock, { passive: true }));
}
